type Preschool = {
  PreschoolCDSCode: string;
  PreschoolName: string;
};

type RoleItem = {
  Value: string;
  Text: string;
};

type StaffForHeading = {
  StaffLegalFirstName?: string | null;
  StaffLegalLastName?: string | null;
  LocalStaffId?: string | null;
  PreschoolCode?: string | null;
  SEID?: string | null;
};

type SassForHeading = {
  ClassroomRole1?: string | null;
  NonClassroomRole1?: string | null;
};

export function buildStaffHeadingModel({
  staff,
  leaid,
  sassRecords,
  preschools,
  staffRoleList,
  nonClassroomRoleList,
}: {
  staff: StaffForHeading;
  leaid: string;
  sassRecords: SassForHeading[];
  preschools: Preschool[];
  staffRoleList: RoleItem[];
  nonClassroomRoleList: RoleItem[];
}) {
  const staffName =
    `${staff.StaffLegalFirstName ?? ""} ${staff.StaffLegalLastName ?? ""}`.trim();

  const first = staff.StaffLegalFirstName?.[0] ?? "";
  const last = staff.StaffLegalLastName?.[0] ?? "";
  const initials = `${first}${last}`.trim() || staff.LocalStaffId?.[0] || "?";

  const school =
    preschools.find((x) => x.PreschoolCDSCode === staff.PreschoolCode)
      ?.PreschoolName ?? "Unknown preschool";

  const classroomRoleValue = sassRecords[0]?.ClassroomRole1 ?? undefined;
  const nonClassroomRoleValue = sassRecords[0]?.NonClassroomRole1 ?? undefined;

  const classroomRoleText =
    classroomRoleValue &&
    staffRoleList.find((r) => r.Value === classroomRoleValue)?.Text;

  const nonClassroomRoleText =
    nonClassroomRoleValue &&
    nonClassroomRoleList.find((r) => r.Value === nonClassroomRoleValue)?.Text;

  const primaryRole = classroomRoleText || nonClassroomRoleText || undefined;

  return {
    staffName,
    initials,
    leaid,
    school,
    seid: staff.SEID ?? "",
    localId: staff.LocalStaffId ?? "",
    primaryRole,
  };
}
